import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {environment} from 'src/environments/environment';
import {map, catchError} from 'rxjs/operators';
import {HelpersService} from 'src/core/services/helpers.service';
import * as Utils from '../../core/lib/utils';
import {Point} from './models/point';
import {CITIES_EXCEPTIONS, ISTAT_CODES_EXCEPTIONS} from 'src/core/config/map-config';
import {Config, LANDING_CONFIGURATION, SLUG_CONVERTER} from 'src/core/config/landing-config';

@Injectable()
export class LandingPageService {
    public waitBuildings: boolean = false; // to prevent enabling button to soon
    public fileToUpload: any = null;
    private env = environment;


    config: Config = this.env.controls.unique_environment ? LANDING_CONFIGURATION[SLUG_CONVERTER[window.location.pathname.split('/')[1]]] : LANDING_CONFIGURATION[this.env.serviceSlug];
    public mapButtons = {
        pops: {
            active: (this.config.pop.view_initial || this.config.pcn.view_initial || this.config.pop_ola.view_initial || (this.env.controls.agf && this.config.pop_agf.view_initial)),
            tooltip: 'Show POP',
            ico: './assets/images/ico-pop-button.png'
        },
        pfs: {
            active: this.config.pfs.view_initial,
            tooltip: 'Show PFS',
            ico: './assets/images/ico-pfs.png'
        },
        roe: {
            active: this.config.roe.view_initial,
            tooltip: 'Show ROE',
            ico: './assets/images/ico-roe.png'
        },
        cno: {
            active: true, // TODO punti intermedi
            tooltip: 'Show CNO',
            ico: './assets/images/ico-roe.png'
        },
        pozzetto: {
            active: true, // TODO punti intermedi
            tooltip: 'Show POZZETTO',
            ico: './assets/images/ico-roe.png'
        },
        poi: {
            active: this.config.poi.view_initial,
            tooltip: 'Show POI',
            ico: './assets/images/ico-poi-active.png'
        },
        kml: {
            active: false,
            tooltip: 'Show Coverage/Planned Map',
            ico: './assets/images/ico-kml.png'
        },
        legenda: {
            tooltip: 'Legenda',
            ico: './assets/images/ico-legenda.png'
        }
    }

    constructor(private http: HttpClient, private helpersService: HelpersService) {
    }

    getUserInfo(): Observable<any> {
        const url = `${environment.apiUrl}/api2/marketing/user/me`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getAendCities(): Observable<any> {
        const url = `${environment.apiUrl}/api2/marketing/user/aend-cities?service_platform=${this.config.data.dynamic_aend_name}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    checkFeasibility(request): Observable<any> {
        const url = `/api2${this.config.data.api.p2pPath}`;
        return this.http.post(environment.apiUrl + url, request).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((error) => {
                this.helpersService.handleError(error);
                return error;
            }),
        );
    }


    getPops(args?: { olocode?: string, zoom?: number, bbox?: number[] }): Observable<any> {
        const query: any = {}
        query.service_platform = this.config.data.dynamic_aend_name;
        if (args?.olocode) query.olo_code = args.olocode
        if (args?.zoom) query.zoom = args.zoom
        if (args?.bbox?.length) query.in_bbox = args.bbox.join(',')

        const queryString = new URLSearchParams(query).toString()

        return this.http.get(`${environment.apiUrl}/api2/marketing/pops?${queryString}`);
    }


    getNetworkLinkPoints(types: any, clusters: any, city?: any): Observable<any> {
        let typesParams = '';
        let clustersParams = '';
        let cityParam = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        if (clusters && clusters.length) {
            for (const c of clusters) {
                clustersParams += '&clusters[]=' + c;
            }
            ;
        }
        if (city) {
            cityParam += '&city_id=' + city;
        }
        return this.http.get(`${environment.apiUrl}/api2/point/networklinkpoint${typesParams}${clustersParams}${cityParam}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getWavelengthPoints(types: any, clusters: any, city?: any): Observable<any> {
        let typesParams = '';
        let clustersParams = '';
        let cityParam = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        if (clusters && clusters.length) {
            for (const c of clusters) {
                clustersParams += '&clusters[]=' + c;
            }
            ;
        }
        if (city) {
            cityParam += '&city_id=' + city;
        }
        return this.http.get(`${environment.apiUrl}/api2/marketing/pops${typesParams}${clustersParams}${cityParam}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    // TODO
    getNetworkLinkPointsCities(types: any, clusters: any): Observable<any> {
        let typesParams = '';
        let clustersParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        if (clusters && clusters.length) {
            for (const c of clusters) {
                clustersParams += '&clusters[]=' + c;
            }
            ;
        }
        return this.http.get(`${environment.apiUrl}/api2/point/networklinkpoint/cities${typesParams}${clustersParams}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    // TODO
    // getWavelengthPointsCities(types: any, clusters: any): Observable<any> {
    //   let typesParams = '';
    //   let clustersParams = '';
    //   if (types && types.length) {
    //     for (const t of types) {
    //       typesParams += '&types[]=' + t;
    //     };
    //     typesParams = '?' + typesParams;
    //   }
    //   if (clusters && clusters.length) {
    //     for (const c of clusters) {
    //       clustersParams += '&clusters[]=' + c;
    //     };
    //   }
    //  // return this.http.get(`${environment.apiUrl}/api2/marketing/pops/cities${typesParams}${clustersParams}`).pipe(
    //   return this.http.get(`${environment.apiUrl}/api2/marketing/pops/cities`).pipe(
    //     map(data => {
    //       return data;
    //     }),
    //     catchError(error => {
    //       this.helpersService.handleError(error);
    //       return throwError(error);
    //     })
    //   );
    // }

    getPoiList(olocode?): Observable<[]> {
        let isRegistered = ''
        if (this.config.poi.is_registered) {
            isRegistered = '&is_registered=true'
        }
        const filterPoi = '?status=ON-NET'
        const useOloCode = olocode ? `&olo_code=${olocode}` : '';
        return this.http.get<[]>(`${environment.apiUrl}/api2/marketing/poi${filterPoi ? filterPoi : ''}${useOloCode}` + isRegistered);
    }

    getKMLList(): Observable<any> {
        const agfParam = this.env.controls.agf ? '&types=CoveredAGF' : '';
        return this.http.get<any>(
            `${environment.apiUrl}/api2/marketing/kml/list/italy?types[]=CoveredAB&types[]=CoveredCD${agfParam}`,
        );
    }

    getBtsCities(types): Observable<any> {
        let typesParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        const url = `${environment.apiUrl}/api2/point/bts/cities${typesParams}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getBtsList(city, types): Observable<any> {
        let typesParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        const url = `${environment.apiUrl}/api2/point/bts${typesParams}&city_id=${city}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }


//   elenco comuni con pop o poi presenti:
// /api2/marketing/pops/cities
// /api2/marketing/poi/cities

// Elenco di pop o poi in una città:
// come per il solito elenco completo ma con il query param id_city
// es.
// /api2/marketing/pops?city_id=6670
// /api2/marketing/poi?city_id=6670&status=ON-NET&olo_code=WN&is_registered=true

    getWavelenghtCitiesPop(): Observable<any> {

        const url = `${environment.apiUrl}/api2/marketing/pops/cities?service_platform=${this.config.data.dynamic_aend_name}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }


    getWavelenghtCitiesPoi(olo): Observable<any> {
        let isRegistered = ''
        if (this.config.poi.is_registered) {
            isRegistered = '&is_registered=true'
        }
        const url = `${environment.apiUrl}/api2/marketing/poi/cities?status=ON-NET&olo_code=${olo}` + isRegistered;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getPopWavelenghtList(city): Observable<any> {

        const url = `${environment.apiUrl}/api2/marketing/pops?&city_id=${city}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getPoiWavelenghtList(city, olo): Observable<any> {
        let isRegistered = ''
        if (this.config.poi.is_registered) {
            isRegistered = '&is_registered=true'
        }

        const url = `${environment.apiUrl}/api2/marketing/poi?city_id=${city}&status=ON-NET&olo_code=${olo}` + isRegistered;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getBuildingById(id): Observable<any> {
        let typeParams = '';
        this.config.area_types.forEach(a => {
            if ((this.env.controls.agf && a === 'CoveredAGF') || a !== 'CoveredAGF') {
                typeParams += '&types[]=' + a;
            }
        });

        if (this.config.data?.api?.buildingSearchParams) {
            for (const key in this.config.data.api.buildingSearchParams) {
                const val = this.config.data.api.buildingSearchParams[key]
                typeParams += `&${key}=${val}`
            }
        }

        return this.http.get<any>(`${environment.apiUrl}/api2/marketing/building/of?building_id=${id}${typeParams}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }


    getBtsById(type, id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/point/bts/search?code=${id}&type=${type}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getNoaById(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/marketing/noa/search?identifier_of=${id}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getSchoolById(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/marketing/school/search?code=${id}&service_name=${this.config.data.service_name}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getHealthcareById(id): Observable<any> {
        const typeParams = 'CoveredHealthcareCD';
        return this.http.get<any>(`${environment.apiUrl}/api2/point/healthcare/search?code=${id}&types[]=${typeParams}&service_name=${this.config.data.service_name}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getNetworkLinkPointById(code, type): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/point/networklinkpoint/search?code=${code}&type=${type}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getBuildingByCoordinates(lat, lng): Observable<any> {
        let typeParams = '';

        this.config.area_types.forEach(a => {
            if ((this.env.controls.agf && a === 'CoveredAGF') || a !== 'CoveredAGF') {
                typeParams += '&types[]=' + a;
            }
        });

        if (this.config.data?.api?.buildingSearchParams) {
            for (const key in this.config.data.api.buildingSearchParams) {
                const val = this.config.data.api.buildingSearchParams[key]
                typeParams += `&${key}=${val}`
            }
        }

        return this.http.get<any>(`${environment.apiUrl}/api2/marketing/building/coordinates-search?lng=${lng}&lat=${lat}${typeParams}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getBtsByCoordinates(lat, lng, types): Observable<any> {
        let typesParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
        }
        return this.http.get<any>(`${environment.apiUrl}/api2/point/bts/coordinates-search?lat=${lat}&lng=${lng}${typesParams}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getSchoolsByCoordinates(lat, lng): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/marketing/school/coordinates-search?lng=${lng}&lat=${lat}&service_name=${this.config.data.service_name}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getHealthcareByCoordinates(lat, lng): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api2/point/healthcare/coordinates-search?lng=${lng}&lat=${lat}&service_name=${this.config.data.service_name}`).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    searchBuildingPlaceholders(bounds: google.maps.LatLngBounds, zoom): Observable<any> {
        this.waitBuildings = true;

        const bbox = `${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()},${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}`;

        let typeParams = '';
        this.config.area_types.forEach(a => {
            if ((this.env.controls.agf && a === 'CoveredAGF') || a !== 'CoveredAGF') {
                typeParams += '&types[]=' + a;
            }
        });

        if (this.config.data?.api?.buildingSearchParams) {
            for (const key in this.config.data.api.buildingSearchParams) {
                const val = this.config.data.api.buildingSearchParams[key]
                typeParams += `&${key}=${val}`
            }
        }

        const url = `${environment.apiUrl}/api2/marketing/building?in_bbox=${bbox}&zoom=${zoom.toString()}${typeParams}`;

        return this.http.get<any>(url).pipe(
            map(data => {
                this.waitBuildings = false;
                return data;
            }),
            catchError(error => {
                this.waitBuildings = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getBtsBbox(types: string[], bounds: google.maps.LatLngBounds, zoom): Observable<any> {
        let typesParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
        }
        this.waitBuildings = true;
        const bbox = `${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()},${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}`;
        const url = `${environment.apiUrl}/api2/point/bts/building?in_bbox=${bbox}&zoom=${zoom.toString()}${typesParams}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                this.waitBuildings = false;
                return data;
            }),
            catchError(error => {
                this.waitBuildings = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    getPuntiIntermediBbox(types: string[], clusters: any, bounds: google.maps.LatLngBounds, zoom): Observable<any> {
        let typesParams = '';
        let clustersParams = '';
        if (types && types.length) {
            for (const t of types) {
                typesParams += '&types[]=' + t;
            }
            ;
            typesParams = '?' + typesParams;
        }
        if (clusters && clusters.length) {
            for (const c of clusters) {
                clustersParams += '&clusters[]=' + c;
            }
            ;
        }
        this.waitBuildings = true;
        const bbox = `${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()},${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}`;
        const url = `${environment.apiUrl}/api2/point/networklinkpoint/building?in_bbox=${bbox}&zoom=${zoom.toString()}${typesParams}${clustersParams}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                this.waitBuildings = false;
                return data;
            }),
            catchError(error => {
                this.waitBuildings = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    searchSchoolBBox(bounds: google.maps.LatLngBounds, zoom): Observable<any> {
        this.waitBuildings = true;
        const bbox = `${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()},${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}`;
        const typeParams = 'CoveredSchoolCD';
        const url = `${environment.apiUrl}/api2/marketing/school/building?in_bbox=${bbox}&zoom=${zoom.toString()}&types[]=${typeParams}&service_name=${this.config.data.service_name}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                this.waitBuildings = false;
                return data;
            }),
            catchError(error => {
                this.waitBuildings = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    searchHealthcareBBox(bounds: google.maps.LatLngBounds, zoom): Observable<any> {
        this.waitBuildings = true;
        const typeParams = 'CoveredHealthcareCD';
        const bbox = `${bounds.getSouthWest().lng()},${bounds.getSouthWest().lat()},${bounds.getNorthEast().lng()},${bounds.getNorthEast().lat()}`;
        const url = `${environment.apiUrl}/api2/point/healthcare/building?in_bbox=${bbox}&zoom=${zoom.toString()}&types[]=${typeParams}&service_name=${this.config.data.service_name}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                this.waitBuildings = false;
                return data;
            }),
            catchError(error => {
                this.waitBuildings = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    convertCoordinates(lat, lng): Observable<any> {
        let url = `${environment.apiUrl}/api2/coordinates/convert?lat=${lat}&lng=${lng}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    checkIfBuilding(buildingsList, point): any {
        let p = new Point;
        if (buildingsList && buildingsList.results && buildingsList.results.length) {
            const placeLat = point.coordinates && point.coordinates.lat() ? String(point.coordinates.lat()).substring(0, 7) : String(point.geometry.location.lat()).substring(0, 7);
            const placeLng = point.coordinates && point.coordinates.lng() ? String(point.coordinates.lng()).substring(0, 7) : String(point.geometry.location.lng()).substring(0, 7);
            for (const b of buildingsList.results) {
                if (String(b.coordinates.coordinates[1]).substring(0, 7) === placeLat && String(b.coordinates.coordinates[0]).substring(0, 7) === placeLng) {
                    p.address = b.indirizzo_completo;
                    p.label = b.id_building ? b.id_building : b.id;
                    p.type = 'Building';
                    p.research_method = Utils.RESEARCH_METHODS.id_building;
                    p.coordinates = b.coordinates.coordinates ? {
                        lat: b.coordinates.coordinates[1],
                        lng: b.coordinates.coordinates[0]
                    } : {lat: b.lat, lng: b.lng};
                    p.comune = b.comune ? b.comune : null;
                    return p;
                }
            }
        }
    }

    isCityException(city) {
        if (!city) {
            return false;
        }
        let ret;
        CITIES_EXCEPTIONS.forEach(c => {
            if (city.includes(c)) {
                ret = true
            }
            ;
        });
        return ret;
    }

    isIstatCodeException(code) {
        if (!code) {
            return false;
        }
        let ret;
        ISTAT_CODES_EXCEPTIONS.forEach(c => {
            if (code.includes(c)) {
                ret = true
            }
            ;
        });
        return ret;
    }

    uploadFile(request , massiveBeaUpload: boolean): Observable<any> {
        //nal caso di upload bea, uso un endpoint diverso
        const url = `/api2${massiveBeaUpload ? this.config.data.api.massiveImport.massiveUploadBeaPath : this.config.data.api.massiveImport.massiveUploadPath}`;
        return this.http.post(environment.apiUrl + url, request).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((error) => {
                this.helpersService.handleError(error);
                return throwError(error);
            }),
        );
    }

    getMassiveDetail(id, page): Observable<any> {
        let url = `${environment.apiUrl}/api2${this.config.data.api.massiveImport.massiveDetailsPath}/${id}?page=${page}&page_size=10`;
        return this.http.get<any>(url).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

    sendToSalesforce(request): Observable<any> {
        const url = `/api2${this.config.data.api.massiveImport.massiveP2pSalesforcePath}`;
        return this.http.post(environment.apiUrl + url, request).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((err) => {
                return throwError(err);
            }),
        );
    }

    public getExcelTemplate(downloadPath): Observable<Blob> {
        const url = `/api2${downloadPath}`;
        return this.http.get(environment.apiUrl + url, {responseType: 'blob'});
    }

    getDataFromIdTrasloco(id, mode = 'edit'): Observable<any> {
        //   const url = 'https://reqres.in/api/users';
        //   const body = {
        //     "id_risorsa": id,
        //     "p1": {
        //         "is_editable": false,
        //         "coordinates": {
        //             "lng": 9.1709754,
        //             "lat": 45.4876689
        //         },
        //         "label": "03_015_015146_8000051004_10",
        //         "id": "136041",
        //         "id_building": "03_015_015146_8000051004_10",
        //         "type": "BUILDING",
        //         "comune": "Milano",
        //         "provincia": "MI",
        //         "street": "Via Cenisio",
        //         "street_number": "10",
        //         "research_method": "Building"
        //     },
        //     "p2": {
        //         "is_editable": true,
        //         "coordinates": {
        //           "lng": 9.16862,
        //           "lat": 45.488077
        //         },
        //         "label": "03_015_015146_8000051004_20",
        //         "id": "136055",
        //         "id_building": "03_015_015146_8000051004_20",
        //         "type": "BUILDING",
        //         "comune": "Milano",
        //         "provincia": "MI",
        //         "street": "Via Cenisio",
        //         "street_number": "20",
        //         "research_method": "Building"
        //     },
        //     "p3": {
        //         "is_editable": false,
        //         "coordinates": {
        //           "lng": 9.168276,
        //           "lat": 45.487819
        //         },
        //         "label": "03_015_015146_8000051004_30",
        //         "id": "166495",
        //         "id_building": "03_015_015146_8000051004_30",
        //         "type": "BUILDING",
        //         "comune": "Milano",
        //         "provincia": "MI",
        //         "street": "Via Cenisio",
        //         "street_number": "20",
        //         "research_method": "Building"
        //     }
        // }

        let url = `${environment.apiUrl}/api2/marketing/change-order/info`;
        const body = {
            "id_risorsa": id,
            "mode": mode
        };
        return this.http.post(url, body).pipe(
            map(data => {
                return data;
            }),
            catchError(error => {
                error.isEnabled = false;
                this.helpersService.handleError(error);
                return throwError(error);
            })
        );
    }

  //rimpiazza getAendCities uniformità delle varie landing
  getConfigurations(): Observable<any> {
    const url = `${environment.apiUrl}/api2/marketing/user/configurations?service_platform=${this.config.data.dynamic_aend_name}`;
    return this.http.get<any>(url).pipe(
        map(data => {
          return data;
        }),
        catchError(error => {
          this.helpersService.handleError(error);
          return throwError(error);
        })
    );
  }

}
